import teamRequestsListComponent from './teamRequestsList.component';
import teamRequestCard from './teamRequestCard/teamRequestCard';
import teamRequestsFilters from './teamRequestsFilters/teamRequestsFilters';

let teamRequestsListModule = angular.module('vacations-absences.teamRequestsList', [
  teamRequestCard,
  teamRequestsFilters
])

.component('teamRequestsList', teamRequestsListComponent)

.name;

export default teamRequestsListModule;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/features/teamRequests/teamRequestsList/teamRequestsList.js